import {
    Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
    TextField, Select, MenuItem, Checkbox, TextareaAutosize
} from "@material-ui/core";
import {useEffect, useState} from "react";
import {client} from "../../dataProvider";
import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import {BsTextarea} from "react-icons/bs";
import {DateField, useNotify} from "react-admin";
import {DatePicker} from "@material-ui/pickers";

export function LastDateActivity({row}: { row: any }) {
    const [date, setDate] = useState<string>("");
    useEffect(() => {
        let lastReminder;
        if (row.last_reminder)
            lastReminder = row.last_reminder
        else
            return
        const newDate = new Date(lastReminder.date_activity)
        setDate(newDate.toLocaleString("it-IT").split(",")[0])
    }, [row.id])

    return <div>{date}</div>
}


export function CreateReminder({row}: { row: any }) {
    const [open, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState<any[]>([]);
    const [lastReminder, setLastReminder] = useState(null)

    const [form, setForm] = useState({
        communication_method: "",
        notes: "",
        email_text: "",
        date_activity: new Date().toISOString().split("T")[0],
        send_email: false
    });

    useEffect(() => {
        setData(row.reminders)
        if (row.last_reminder)
            setLastReminder(row.last_reminder)
        else {
            setLastReminder(row.reminders.filter((reminder: any) => !reminder.canceled).reduce((latest: any, current: any) => {
                if (!latest) return current;

                return new Date(current.creation_date).getTime() >
                new Date(latest.creation_date).getTime()
                    ? current
                    : latest;
            }, undefined))
        }
    }, [row.id]);


    const handleClickOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [showDialog, setShowDialog] = useState(false);
    const notify = useNotify();

    const handleCreate = async () => {
        try {
            setIsLoading(true);
            await client(`debt_collection/${row.id}/create_reminder`, {
                method: "POST",
                data: {
                    payment_schedule_id: row.id,
                    communication_method: form.communication_method,
                    date_activity: form.date_activity,
                    notes: form.notes,
                    email_text: form.email_text,
                },
            }).then((response) => setData([...data, response.reminder]));
            setForm({communication_method: "", notes: "", email_text: "", send_email: false, date_activity: ""});
        } catch (e) {
            console.error("Failed to create reminder:", e);
            notify("Errore nel creare il sollecito, se email è selezionato, assicurati di aver inserito il testo",
                "error")
        } finally {
            setIsLoading(false);
        }
    };


    const deleteReminder = async (reminder_id: string) => {
        try {
            setIsLoading(true);
            await client(`debt_collection/${reminder_id}/delete_reminder`, {
                method: "POST",
            }).then((response) => setData(data.filter((r) => r.id !== reminder_id)));
        } catch (e) {
            console.error("Failed to delete reminder:", e);
        } finally {
            setIsLoading(false);
        }
    }


    return (
        <Box display="flex" alignItems="center">
            <Button variant="outlined" size="small" color="primary" onClick={handleClickOpen}>
                {data.filter((reminder: any) => !reminder.canceled).length} solleciti
                {
                    // @ts-ignore
                    lastReminder && lastReminder["communication_method_display"] ? ("->" + lastReminder["communication_method_display"]) : ""
                }
            </Button>

            <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} maxWidth="md" fullWidth>
                <DialogTitle disableTypography>
                    <Typography variant="h6">Crea sollecito</Typography>
                </DialogTitle>

                <DialogContent dividers>
                    {isLoading ? (
                        <CircularProgress color="primary"/>
                    ) : (
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>N</TableCell>
                                        <TableCell>Data attività</TableCell>
                                        <TableCell>Canale</TableCell>
                                        <TableCell>Data</TableCell>
                                        <TableCell>Note</TableCell>
                                        <TableCell>Annulla</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.map((r, index) => (
                                        <TableRow key={index} style={{
                                            textDecoration: r.canceled === true ? 'line-through' : ""
                                        }}>
                                            <TableCell component="th" scope="row">{index + 1}</TableCell>
                                            <TableCell>{r.date_activity}</TableCell>
                                            <TableCell>{r.communication_method_display}</TableCell>
                                            <TableCell>
                                                {new Date(r.creation_date).toLocaleString("it-IT", {
                                                    day: "2-digit",
                                                    month: "2-digit",
                                                    year: "numeric",
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                })}
                                            </TableCell>
                                            <TableCell>{r.notes}</TableCell>
                                            <TableCell><Button variant="text"
                                                               onClick={() => deleteReminder(r.id)}><DeleteIcon
                                                style={{color: "red"}}/></Button></TableCell>
                                        </TableRow>
                                    ))}

                                    <TableRow>
                                        <TableCell component="th" scope="row">
                                            <Button onClick={handleCreate}><AddIcon/> Crea sollecito</Button>
                                        </TableCell>
                                        <TableCell>
                                            <DatePicker value={form.date_activity}
                                                        onChange={(date) => date && setForm((prev) => ({
                                                            ...prev,
                                                            date_activity: date.toISOString().split("T")[0]
                                                        }))}/>
                                        </TableCell>
                                        <TableCell>
                                            <Select
                                                fullWidth
                                                value={form.communication_method}
                                                onChange={(e) =>
                                                    setForm((prev) => ({
                                                        ...prev,
                                                        communication_method: e.target.value as string
                                                    }))
                                                }
                                                displayEmpty
                                            >
                                                <MenuItem value="" disabled>Seleziona canale</MenuItem>
                                                <MenuItem value="MAIL">Mail</MenuItem>
                                                <MenuItem value="CALL">Chiamata</MenuItem>
                                                <MenuItem value="LEGAL_PRACTICE">Pratica legale</MenuItem>
                                                <MenuItem value="DRIVER_PASSAGE">Passaggio autista</MenuItem>
                                            </Select>
                                        </TableCell>
                                        <TableCell>
                                            Invia email?
                                            <Checkbox
                                                onChange={(e) => setForm((prev) => ({
                                                    ...prev,
                                                    send_email: e.target.checked
                                                }))}
                                            />
                                            <Button onClick={() => setShowDialog(true)} color="primary">
                                                Apri testo mail
                                            </Button>
                                            <Dialog open={showDialog} fullWidth={true} maxWidth={"xl"}
                                                    onClose={() => setShowDialog(false)}
                                                    aria-labelledby="form-dialog-title">
                                                <DialogTitle>Testo email</DialogTitle>
                                                <DialogContent>
                                                    <Select fullWidth={true}
                                                            placeholder={"Selezione template email"}
                                                            onChange={(e) => {
                                                                if (e.target.value === "1") {
                                                                    setForm((prev) => ({
                                                                        ...prev, email_text: `Gentile cliente,
riportiamo in allegato il Suo estratto conto relativo al ns avere alla data odierna.

La preghiamo pertanto di regolarizzare al più presto la sua posizione contabile, ricordando che il pagamento può essere effettuato a mezzo bonifico bancario, utilizzando i riferimenti presenti nella fattura elettronica.

Nel caso in cui il bonifico sia stato già disposto, potrà ritenere nulla la presente richiesta.
In attesa di suo gradito riscontro e restando a disposizione per eventuali delucidazioni,
ci è gradita l’occasione per porgere distinti saluti.

AREA RECUPERO CREDITI Supersonica SRL - 08281817811`
                                                                    }))

                                                                } else if (e.target.value === "2") {
                                                                    setForm((prev) => ({
                                                                        ...prev, email_text: `Gentile cliente,
testo numero 2.`
                                                                    }))

                                                                } else {
                                                                    setForm((prev) => ({
                                                                        ...prev, email_text: `Gentile cliente,
testo numero 3.`
                                                                    }))
                                                                }
                                                            }}>
                                                        <option value="1" selected>Email 1</option>
                                                        <option value="2">Email 2</option>
                                                        <option value="3">Email 3</option>
                                                    </Select>
                                                    <br/>
                                                    <TextField
                                                        multiline={true}
                                                        fullWidth={true}
                                                        value={form.email_text}
                                                        onChange={(e) => setForm((prev) => ({
                                                            ...prev,
                                                            email_text: e.target.value
                                                        }))}
                                                        placeholder=""
                                                    />
                                                </DialogContent>
                                            </Dialog>


                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                fullWidth
                                                value={form.notes}
                                                onChange={(e) => setForm((prev) => ({...prev, notes: e.target.value}))}
                                                placeholder="Note..."
                                            />
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </DialogContent>

                <DialogActions>
                    <Button aria-label="close" onClick={handleClose}>Chiudi</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}
